import type { PodMode } from '@/types/pods';
import { validateEngagementPodUrl } from '@shared/engagementPodCapabilities';

export interface ParsedPodUrl {
	success: boolean;
	url?: string;
	username?: string;
	conversationId?: string;
	error?: string;
}

export function parsePodTargetUrl(
	rawUrl: string,
	{
		platform,
		mode,
	}: {
		platform: string;
		mode?: PodMode | string | null;
	}
): ParsedPodUrl {
	const podMode: PodMode = mode === 'broadcast' ? 'broadcast' : 'swarm';
	const withScheme = rawUrl.trim().match(/^https?:\/\//i)
		? rawUrl.trim()
		: `https://${rawUrl.trim()}`;
	const parsed = validateEngagementPodUrl({
		url: withScheme,
		platform,
		mode: podMode,
	});
	if (!parsed.ok) return { success: false, error: parsed.error };
	return {
		success: true,
		url: parsed.url,
		username: parsed.username,
		conversationId: parsed.conversationId,
	};
}

export function extractUrlCandidatesFromText(text: string) {
	const candidates = new Set<string>();
	const addCandidate = (value: string) => {
		const trimmed = value.trim().replace(/^["']|["']$/g, '');
		if (!trimmed) return;
		if (/^(https?:\/\/|www\.|[a-z0-9.-]+\.[a-z]{2,}(?:\/|$))/i.test(trimmed)) {
			candidates.add(trimmed);
		}
	};
	const urlMatches = text.match(/https?:\/\/[^\s,"')]+/gi) || [];
	for (const match of urlMatches) {
		addCandidate(match);
	}

	for (const line of text.split(/\r?\n/)) {
		for (const cell of line.split(',')) {
			addCandidate(cell);
		}
	}

	return Array.from(candidates);
}
